export default {
  //字典表
  LISTDATA_DICTBYDATACODE: '/maindata/dictData/listDataDictByDataType',
  // 查询公司树
  LISTDATA_SERECHCOMPANYTREE: '/maindata/company/listCompanyOneDepartmentTree',
  //资金预报表查询(无分页)
  QUERY_LIST: '/financial/fundPlanForecast/queryList',
  //资金预报表合计
  COMBINED: '/financial/fundPlanForecast/combined',
  //资金预报表外币报表查询
  QUERY_FOREIGN_CURRENCY: '/financial/fundPlanForecast/queryForeignCurrency',
  //维护银行余额
  SET_FUND_PLAN_BALANCE: '/financial/fundPlanForecast/setFundPlanBalance',
  //人民币报表列表excel导出
  FORECAST_EXPORT_EXCEL: '/financial/fundPlanForecast/exportExcel',
  //外币报表列表excel导出
  FORECAST_CURRENCY_EXPORT_EXCEL: '/financial/fundPlanForecast/exportForeignCurrencyExcel',
  //查询维护银行余额记录
  QUERY_FUND_PLAN_BALANCE_RECORDS: '/financial/fundPlanForecast/queryPlanAmount',
};
